<template>
<router-link class="is-block category-tile featured" :to="item.link">
    <div class="category-tile__bg" :style="'background-image: url(' + item.bg.url + ');'"></div>
    <div class="category-tile__inner">
        <p v-if="item.subtitle" class="subtitle is-5">{{item.subtitle}}</p>
        <h2 class="title is-2">{{item.title}}</h2>
        <div class="action">
            <span class="button">Browse</span>
        </div>
    </div>
</router-link>
</template>

<script>
export default {
    name    :   'FeaturedCategoryTile',
    props   :   ['item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/FeaturedCategoryTile.vue